import { ServerResponse } from "@core/server/domain/server.interface";
import {
  farmerRegistrationApi,
  getProfileApi,
  logoutApi,
} from "@core/server/utils/apis";
import {
  FarmerRegistration,
  Profile,
} from "@/features/farmer/domain/farmer-interface";

export async function getProfile(farmerId: string) {
  const response: Promise<ServerResponse<Profile> | undefined> =
    await getProfileApi(farmerId);
  return (await response)?.data;
}

export async function logout() {
  const response: Promise<ServerResponse<string> | undefined> =
    await logoutApi();
  return (await response)?.data;
}

export async function farmerRegistration(farmerInfo: FarmerRegistration) {
  const response: Promise<ServerResponse<string> | undefined> =
    await farmerRegistrationApi(farmerInfo);
  return (await response)?.data;
}
